import api from './core/api';

export type MobileAppKey = 'user' | 'partner' | 'vendor' | 'provider';
export type MobilePlatform = 'android' | 'ios';

export interface MobileAppVersionRow {
  _id: string;
  app: MobileAppKey;
  platform: MobilePlatform;
  version: string;
  buildNumber?: string;
  storeUrl: string;
  releaseNotes?: string;
  uploadedAt?: string;
  isActive: boolean;
  isLatest: boolean;
  isMinRequired: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface MobileAppVersionPayload {
  app: MobileAppKey;
  platform: MobilePlatform;
  version: string;
  buildNumber?: string;
  storeUrl: string;
  releaseNotes?: string;
  uploadedAt?: string;
  isActive?: boolean;
  isLatest?: boolean;
  isMinRequired?: boolean;
}

export async function listMobileAppVersions(params?: { app?: string; platform?: string }) {
  const res = await api.get('/admin/app-versions', { params });
  return (res.data.data || []) as MobileAppVersionRow[];
}

export async function createMobileAppVersion(payload: MobileAppVersionPayload) {
  const res = await api.post('/admin/app-versions', payload);
  return res.data.data as MobileAppVersionRow;
}

export async function updateMobileAppVersion(id: string, payload: Partial<MobileAppVersionPayload>) {
  const res = await api.put(`/admin/app-versions/${id}`, payload);
  return res.data.data as MobileAppVersionRow;
}

export async function deleteMobileAppVersion(id: string) {
  const res = await api.delete(`/admin/app-versions/${id}`);
  return res.data.data as MobileAppVersionRow;
}
